import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { InlineSpinner } from "components/common/InlineSpinner";

interface LoadMoreButtonProps {
  onClick: () => void;
  isLoading: boolean;
  label?: string;
}

export const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({
  onClick,
  isLoading,
  label = "Load more",
}) => (
  <button
    type="button"
    className="text-accent-medium item-height px-2 gap-2 flex items-center rounded-app hover:bg-list-hover cursor-pointer transition-colors"
    onClick={onClick}
    disabled={isLoading}
  >
    {isLoading ? (
      <InlineSpinner size={16} />
    ) : (
      <>
        {label}
        <ExpandMoreIcon className="icon-xs" />
      </>
    )}
  </button>
);
